import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "card-title mt-0 mb-4" }
const _hoisted_4 = { class: "d-flex justify-content-end m-3" }

import DisplayDeliveryPlanInformation from '@/components/DailyReportEdit/Merge/DisplayDeliveryPlanInformation.vue';
import DailyReportMergeFormDetail from '@/components/DailyReportEdit/Merge/MergeFormDetail.vue';
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import getDailyReportEditStatus from '@/types/responses/getDailyReportEditStatus';
import divideDailyReportsResponse from '@/types/responses/divideDailyReports';
import RegisterModal from '@/components/DailyReportEdit/Merge/RegisterModal.vue';
import CompleteModal from '@/components/DailyReportEdit/Split/CompleteModal.vue';
import { useAuth } from '@/services/user/Auth0UserProvider';
import Api from '@/services/api/ApiServiceFabrick';
import { ref, Ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'MergeForm',
  props: {
    deliveryPlanId: {},
    deliveryPlan: {},
    switchContentLoading: { type: Function },
    showFlash: { type: Function }
  },
  setup(__props: any) {

const { loginWithRedirect } = useAuth();
const router = useRouter();
const isLoading: Ref<boolean> = ref(false);
const isOpenDialog: Ref<boolean> = ref(false);
const isDisplayCompleteModal: Ref<boolean> = ref(false);
const deliveryPlanChildren = ref<getDailyReportEditStatus[]>([]);

const props = __props;

onMounted(() => {
  getDailyReportEditStatusChildren();
});

function getDailyReportEditStatusChildren() {
  Api().getDailyReportEditStatusChildren(props.deliveryPlanId).then((data: getDailyReportEditStatus[]) => {
    deliveryPlanChildren.value = data;
  }).catch((error) => {
    errorHandler(error);
  }).finally(() => {
    props.switchContentLoading(false);
  });
}

function execMerge() {
  isLoading.value = true;
  Api().mergeDailyReports(props.deliveryPlanId).then((data: divideDailyReportsResponse) => {
    if (data.status) {
      return isDisplayCompleteModal.value = true;
    }
    props.showFlash(i18n.global.t('pages.dailyReports.splitForm.failedMessage'), 'error', true);
  }).catch((error) => {
    errorHandler(error);
  }).finally(() => {
    isLoading.value = false;
  });
}

function errorHandler(error: any) {
  const res = error.response
  switch (res.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      break
    case 403:
      location.reload()
      break
  }
}

function moveDailyReportDisplay() {
  router.push({ name: "DailyReport" })
}

return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_card, { class: "my-4 pa-4" }, {
          default: _withCtx(() => [
            _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.mergeForm.title')), 1),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(DisplayDeliveryPlanInformation, {
                  deliveryPlan: props.deliveryPlan
                }, null, 8, ["deliveryPlan"]),
                _createVNode(DailyReportMergeFormDetail, { deliveryPlanChildren: deliveryPlanChildren.value }, null, 8, ["deliveryPlanChildren"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_btn, {
                class: "ma-2 reset-btn",
                disabled: isLoading.value,
                onClick: moveDailyReportDisplay
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.cancelBtn')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_v_btn, {
                class: "ma-2 exec-btn",
                loading: isLoading.value,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpenDialog.value = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.confirmBtn')), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(RegisterModal, {
      title: _unref(i18n).global.t('pages.dailyReports.mergeConfirmModal.title'),
      modelValue: isOpenDialog.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isOpenDialog).value = $event)),
      execFunction: execMerge
    }, null, 8, ["title", "modelValue"]),
    _createVNode(CompleteModal, {
      modelValue: isDisplayCompleteModal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isDisplayCompleteModal).value = $event)),
      messages: [
      _unref(i18n).global.t('pages.dailyReports.mergeCompleteModal.messageRow1'),
      _unref(i18n).global.t('pages.dailyReports.mergeCompleteModal.messageRow2')
    ],
      moveDailyReportDisplay: moveDailyReportDisplay
    }, null, 8, ["modelValue", "messages"])
  ], 64))
}
}

})